// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root :global .navbar {
  padding-left: 0;
  padding-right: 0;
}
.nav {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #353535;
  height: 40px;
  width: max-content;
  padding-left: 15px;
  padding-right: 15px;
  margin-right: 10px;
}
@media (max-width: 768px) {
  .nav {
    width: 100%;
    margin-right: 0;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.nav:hover {
  text-decoration: none !important;
  background-color: #FFFFFF;
}
.navSelected {
  color: #353535;
  font-size: 13px;
  display: flex;
  width: max-content;
  padding-left: 15px;
  padding-right: 15px;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
}
@media (max-width: 768px) {
  .navSelected {
    width: 100%;
    margin-right: 0;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.navSelected:hover {
  color: #353535;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/App/LayoutContent/Open/ContentOpenNavStatic.less"],"names":[],"mappings":"AAEA;EAEI,eAAA;EACA,gBAAA;AAFJ;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAPF;AAUA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;EARF;AACF;AAYA;EACE,gCAAA;EACA,yBAAA;AAVF;AAaA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACD,yBAAA;EACA,2CAAA;AAXD;AAcA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;EAZF;AACF;AAeA;EACE,cAAA;AAbF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.root {\n  :global .navbar {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  // :global a:not([href]):not([tabindex]) {\n  //   color: unset;\n  // }\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: @text-gray1;\n  height: 40px;\n  width: max-content;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-right: 10px;\n}\n\n@media (max-width: 768px) {\n  .nav {\n    width: 100%;\n    margin-right: 0;\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n}\n\n\n.nav:hover {\n  text-decoration: none !important;\n  background-color: @background-white;\n}\n\n.navSelected {\n  color: @text-gray1;\n  font-size: 13px;\n  display: flex;\n  width: max-content;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-right: 10px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n\tbackground-color: @background-white;\n\tbox-shadow: 0 2px 9px 0 rgba(0,0,0,0.03);\n}\n\n@media (max-width: 768px) {\n  .navSelected {\n    width: 100%;\n    margin-right: 0;\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n}\n\n.navSelected:hover {\n  color: @text-gray1;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
